import AuditTrail from './audit-trail.component';
import { AUDIT_TRAIL } from '../../constants/navigations';

export default [
  { path: AUDIT_TRAIL.path, name: 'auditTrail', component: AuditTrail, exact: false },
];
